import bootstrapRollingRestartListener from './rolling-restart';

bootstrapRollingRestartListener();
